import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DriverDetailsDTO } from "../../shared/models/driver-details-dto";
import { DriverDTO } from "../../shared/models/driver-dto";
import { SaveDriverDTO } from "../../shared/models/save-driver-dto";
import { SearchFormDTO } from "src/app/modules/private/modules/driver/search-form-dto";
import { PageManager } from "src/app/shared/models/page-manager";
import { Pagination } from "src/app/shared/models/pagination";
import { EmailDTO } from "src/app/shared/models/email-dto";
import { DriverVehicleListDTO } from "@core/dtos/driver-vehicle";

@Injectable({
  providedIn: "root"
})
export class DriverAPIService {
  private driverUrl = "drivers/";

  constructor(private http: HttpClient) {}

  listAll(): Observable<DriverDTO[]> {
    return this.http.get<DriverDTO[]>(environment.apiUrl + this.driverUrl);
  }

  save(saveDriverDTO: SaveDriverDTO): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + this.driverUrl,
      saveDriverDTO
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + `${this.driverUrl}${id}`);
  }

  findById(id: number): Observable<DriverDetailsDTO> {
    return this.http.get<DriverDetailsDTO>(
      environment.apiUrl + `${this.driverUrl}${id}`
    );
  }

  edit(id: number, saveDriverDTO: SaveDriverDTO): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `${this.driverUrl}${id}`,
      saveDriverDTO
    );
  }

  findByClientId(clientId: number): Observable<DriverDTO[]> {
    return this.http.get<DriverDTO[]>(
      environment.apiUrl + `${this.driverUrl}filters?clientId=${clientId}`
    );
  }

  findVehiclesByDriverId(driverId: number): Observable<DriverVehicleListDTO[]> {
    return this.http.get<DriverVehicleListDTO[]>(
      `${environment.apiUrl}${this.driverUrl}${driverId}/vehicles`
    );
  }

  buildQueryForFilters(searchFormDTO: SearchFormDTO): string {
    let query = "";

    if (searchFormDTO.name) {
      query += `&name=${searchFormDTO.name}`;
    }
    if (searchFormDTO.clientId) {
      query += `&clientId=${searchFormDTO.clientId}`;
    }
    if (searchFormDTO.nameAndUsername) {
      query += `&nameAndUsername=${searchFormDTO.nameAndUsername}`;
    }
    if (searchFormDTO.licensePlate) {
      query += `&licensePlate=${searchFormDTO.licensePlate}`;
    }
    if (searchFormDTO.ignoreDriverWithVehicleId) {
      query += `&ignoreDriverWithVehicleId=${searchFormDTO.ignoreDriverWithVehicleId}`;
    }

    return query;
  }

  findByFilters(
    searchFormDTO: SearchFormDTO,
    pageManager: PageManager,
    sort: string
  ): Observable<Pagination<DriverDTO[]>> {
    const query = this.buildQueryForFilters(searchFormDTO);

    return this.http.get<Pagination<DriverDTO[]>>(
      environment.apiUrl +
        `${this.driverUrl}filters?page=${pageManager.pageIndex}&size=${pageManager.pageSize}${query}${sort}`
    );
  }

  sendEmailByFilters(searchFormDTO: SearchFormDTO, emailDTO: EmailDTO) {
    const query = this.buildQueryForFilters(searchFormDTO);

    return this.http.post<any>(
      `${environment.apiUrl}${this.driverUrl}email?${query}`,
      emailDTO
    );
  }

  updateAccess(id: number): Observable<void> {
    let params = new HttpParams();
    params = params.append("platform", "WEB");

    return this.http.put<void>(
      `${environment.apiUrl}${this.driverUrl}${id}/access`,
      null,
      { params }
    );
  }
}
